import { render, staticRenderFns } from "./CepTelDogrulama.vue?vue&type=template&id=b07fdab0&scoped=true&"
import script from "./CepTelDogrulama.vue?vue&type=script&lang=js&"
export * from "./CepTelDogrulama.vue?vue&type=script&lang=js&"
import style0 from "./CepTelDogrulama.vue?vue&type=style&index=0&id=b07fdab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07fdab0",
  null
  
)

export default component.exports